export default {
    props: {
        zoomableMousewheel: {
            type: Boolean,
            default: undefined,
            kComposite: 'zoomable.mousewheel'
        }, 
        zoomableMousewheelLock: {
            type: String,
            default: undefined,
            kComposite: 'zoomable.mousewheel.lock'
        }, 
        zoomableSelection: {
            type: Boolean,
            default: undefined,
            kComposite: 'zoomable.selection'
        }, 
        zoomableSelectionKey: {
            type: String,
            default: undefined,
            kComposite: 'zoomable.selection.key'
        }, 
        zoomableSelectionLock: {
            type: String,
            default: undefined,
            kComposite: 'zoomable.selection.lock'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/Zoomable.js